import { useEffect } from 'react'

import { useMutation, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'
import { useContextStore } from '@/stores/context'

import type { UserAccountContext } from './get-user-account-context.types'

const getUserAccountContext = async (): Promise<UserAccountContext> => {
  const response = await apiClient.get<UserAccountContext>(
    '/v1/auth/user-account-context',
  )
  return response.data
}

/**
 * Hook to get current user account context (query version)
 * GET /v1/auth/user-account-context
 */
export const useUserAccountContext = () => {
  const setAccountContext = useContextStore(
    (state) => state.setUserAccountContext,
  )

  const query = useQuery({
    queryKey: ['user-account-context'],
    queryFn: () => getUserAccountContext(),
  })

  useEffect(() => {
    if (query.data) {
      setAccountContext(query.data)
    }
  }, [query.data, setAccountContext])

  return query
}

/**
 * Hook to get current user account context (mutation version)
 * GET /v1/auth/user-account-context
 */
export const useUserAccountContextMutation = () => {
  return useMutation({
    mutationFn: () => getUserAccountContext(),
    meta: {
      skipErrorMessage: true,
    },
  })
}
